/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import React from 'react'
import {useIntl} from 'react-intl'
import {Box, useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui'
import Optimizely from '../../../components/optimizely'
import {useGlobalSearch} from '../../../contexts/global-elements-context'
// TODO: refactor — legacy `optimizely/assets/recommendationsCarousel` removed in GDI cleanup, awaiting PDP/PLP refactor
const RecommendationsCarousel = () => null
import {useBrand} from '../../../contexts/brand-context'

const EmptySearchResults = () => {
    const intl = useIntl()
    const {isGarage} = useBrand()
    const styles = useMultiStyleConfig('PlpSrpPages')
    const {data: globalSearchData, isLoading: isSearchLoading} = useGlobalSearch()
    const searchContentArea = globalSearchData?.contentArea || []

    return (
        <Box data-testid="sf-product-empty-list-page" px={{base: 2, lg: 0}} marginTop={{base: 12, lg: 16}}>
            {/* VickyAI Product Recommendations */}
            <RecommendationsCarousel
                Title={intl.formatMessage(
                    isGarage
                        ? {
                              id: 'empty_search_results.carousel.title_garage',
                              defaultMessage: "WE THINK YOU'LL LOVE..."
                          }
                        : {
                              id: 'empty_search_results.carousel.title_dynamite',
                              defaultMessage: "We think you'll love these..."
                          }
                )}
                TitleStyle={styles.emptySearchCarouselTitle}
                slidesToShowDesktop={6.5}
                AIModel="recommendations"
                carouselID="empty-search-recommendations"
            />

            {/* Render search content area from global data */}
            {!isSearchLoading && searchContentArea.length > 0 && (
                <Box>
                    {searchContentArea.map((contentItem) => (
                        <Optimizely
                            key={contentItem.id}
                            content={{items: [contentItem.expanded]}}
                        />
                    ))}
                </Box>
            )}
        </Box>
    )
}

export default EmptySearchResults
